import React, { PureComponent, Fragment } from 'react';
import { Spinner } from 'formlabs-web-components/Navigation';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import { analytics } from '../../utils';
import identifyIntegrations from './identifyIntegrations';

import './NewsLetterSignUp.module.css';

class TeaserSignUp extends PureComponent {
  state = {
    submitting: false,
    submitted: false,
    error: false
  };
  onFormSubmit = async e => {
    this.setState({ submitting: true, error: false });
    e.preventDefault();
    const csrftoken = Cookies.get('csrftoken');
    const form = e.target;
    let form_data = new FormData(form);

    analytics.identify(
      form_data.get('tfa_1'),
      {
        email: form_data.get('tfa_1')
      },
      identifyIntegrations
    );
    analytics.track(
      'Newsletter Subscribed',
      {
        category: 'Segment',
        email: form_data.get('tfa_1')
      },
      {
        integrations: {
          Marketo: false,
          'Marketo V2': false
        }
      }
    );

    const response = await fetch(form.action, {
      method: 'POST',
      body: form_data,
      headers: {
        'X-CSRFToken': csrftoken
      }
    });
    const json = await response.json();
    if (json !== 400 && json < 500) {
      this.setState({ submitted: true });
    } else {
      this.setState({ submitted: false, submitting: false, error: true });
    }
  };
  render() {
    const { t } = this.props;
    const { submitting, submitted, error } = this.state;
    return (
      <div styleName="newsletter-default">
        <form
          method="post"
          action="/form_proxy/"
          className="hintsBelow labelsAbove"
          id="tfa_0"
          onSubmit={this.onFormSubmit}
        >
          {!submitted && (
            <Fragment>
              <input
                type="email"
                id="tfa_1"
                name="tfa_1"
                placeholder="Email"
                title={t('Email')}
                required
                className="validate-email required"
              />

              {submitting && (
                <span styleName="submitting">
                  <Spinner size={3} color="#fff" />
                </span>
              )}
              {!submitting && (
                <button type="submit">
                  <i className="fl-arrow-right" />
                </button>
              )}
              {error && (
                <p>{t('There was an error signing up, please try again.')}</p>
              )}
            </Fragment>
          )}
          {submitted && (
            <div styleName="submitted">
              <span>{t('Thanks for your submission.')}</span>
              <i className="fl-baseline-check_circle_outline-24px" />
            </div>
          )}
          <div>
            <input
              type="hidden"
              id="tfa_3"
              name="tfa_3"
              value=""
              placeholder=""
              title="Referral URL"
              className=""
            />

            <input
              type="hidden"
              id="tfa_5"
              name="tfa_5"
              value=""
              placeholder=""
              title="Language Preference"
              className=""
            />

            <input
              type="hidden"
              id="tfa_8"
              name="tfa_8"
              value=""
              placeholder=""
              title="_tfa_mkt_trk"
              className=""
            />

            <input
              type="hidden"
              id="tfa_9"
              name="tfa_9"
              value=""
              placeholder=""
              title="Acquisition Source - First"
              className=""
            />

            <input
              type="hidden"
              id="tfa_10"
              name="tfa_10"
              value=""
              placeholder=""
              title="Acquisition Source - Last"
              className=""
            />

            <input
              type="hidden"
              id="tfa_11"
              name="tfa_11"
              value=""
              placeholder=""
              title="gclid"
              className=""
            />

            <input
              type="hidden"
              id="tfa_12"
              name="tfa_12"
              value=""
              placeholder=""
              title="utm_campaign - First"
              className=""
            />

            <input
              type="hidden"
              id="tfa_13"
              name="tfa_13"
              value=""
              placeholder=""
              title="utm_campaign - Latest"
              className=""
            />

            <input
              type="hidden"
              id="tfa_14"
              name="tfa_14"
              value=""
              placeholder=""
              title="utm_pt - First"
              className=""
            />

            <input
              type="hidden"
              id="tfa_15"
              name="tfa_15"
              value=""
              placeholder=""
              title="utm_pt - Latest"
              className=""
            />

            <input
              type="hidden"
              id="tfa_16"
              name="tfa_16"
              value=""
              placeholder=""
              title="utm_content - First"
              className=""
            />

            <input
              type="hidden"
              id="tfa_17"
              name="tfa_17"
              value=""
              placeholder=""
              title="utm_content - Latest"
              className=""
            />

            <input
              type="hidden"
              id="tfa_18"
              name="tfa_18"
              value=""
              placeholder=""
              title="utm_term - First"
              className=""
            />

            <input
              type="hidden"
              id="tfa_19"
              name="tfa_19"
              value=""
              placeholder=""
              title="utm_term - Latest"
              className=""
            />

            <input
              type="hidden"
              id="tfa_20"
              name="tfa_20"
              value=""
              placeholder=""
              title="utm_medium - First"
              className=""
            />

            <input
              type="hidden"
              id="tfa_21"
              name="tfa_21"
              value=""
              placeholder=""
              title="utm_medium - Latest"
              className=""
            />
            <input
              type="hidden"
              value="4731047"
              name="tfa_dbFormId"
              id="tfa_dbFormId"
            />
            <input
              type="hidden"
              value=""
              name="tfa_dbResponseId"
              id="tfa_dbResponseId"
            />
            <input
              type="hidden"
              value="82796860eda42e177046ff9c322da69d"
              name="tfa_dbControl"
              id="tfa_dbControl"
            />
            <input
              type="hidden"
              value="1"
              name="tfa_dbVersionId"
              id="tfa_dbVersionId"
            />
            <input
              type="hidden"
              value=""
              name="tfa_switchedoff"
              id="tfa_switchedoff"
            />
          </div>
        </form>
      </div>
    );
  }
}

export default withTranslation()(TeaserSignUp);
